export const darkTheme = {
    bg: "#090917",
    bgLight: "#111128",
    primary: "#a855f7",
    text_primary: "#fafafa",
    text_secondary: "#a1a1aa",
    card: "#181830",
    card_light: "#262645",
    button: "#a855f7",
    white: "#FFFFFF",
    black: "#000000",
};

export const lightTheme = {
    bg: "#f8fafc",
    bgLight: "#ffffff",
    primary: "#8b5cf6",
    text_primary: "#0f172a",
    text_secondary: "#475569",
    card: "#ffffff",
    card_light: "#f1f5f9",
    button: "#8b5cf6",
    white: "#FFFFFF",
    black: "#000000",
};
